import { render, staticRenderFns } from "./PendingBoxWebpartTest.vue?vue&type=template&id=66c687d3"
import script from "./PendingBoxWebpartTest.vue?vue&type=script&lang=js"
export * from "./PendingBoxWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports